import Routes from "./routes";
import PrivateRoutes from "./privateRoutes";
export { Routes, PrivateRoutes };
